import { styled } from "@mui/system";
import { Box } from "@mui/material";

import { colors, others } from "../../../styles/colors";
import fontWeight from "../../../styles/mui/fontWeight";

export const OuterGrid = () => ({
  background: others.otherColors[75],
  height: "calc(100vh - 3rem)",
  padding:"2rem 4rem 2rem 4rem"
});

export const HeaderOuterGrid = () => ({
  background: colors.backgroundColor[7],
  padding:"1rem 2rem"
});

export const GridBody = () => ({
  background: others.otherColors[33],
  boxShadow: `0.0487rem 0.15rem 0.78rem ${colors.dropShadow[4]}`,
  opacity: 1,
  padding: "1rem 1rem",
  marginBottom: "0.8rem",
  borderRadius: "0.3rem",
  display: "flex",
});

export const ButtonGrid = () => ({
  display: "flex",
  justifyContent: "flex-end",
  alignItem: "flex-end",
  marginTop: "0.5rem",
});

export const PatientContainerBox = styled(Box)(() => ({
  boxShadow: `0.0487rem 0.15rem 0.78rem ${colors.dropShadow[4]}`,
  backgroundColor: colors.backgroundColor[2],
  borderRadius: "0.3rem",
  marginBottom: "1rem",
  paddingBottom: "1rem",
}));

export const EligibilityHeadCell = () => ({
  backgroundColor: colors.backgroundColor[8],
  opacity: 1,
  padding: "1.2rem 0 1.2rem 2rem",
  borderBottom: "unset",
  textAlign: "left",
  "&.MuiTableCell-root:last-child": {
    borderRadius: "0.7rem",
    paddingLeft: "4.5rem",
    borderBottom: "none",
  },
});

export const PatientTableHeadCell = () => ({
  backgroundColor: colors.backgroundColor[8],
  opacity: 1,
  padding: "1.2rem 0 1.2rem 0",
  borderBottom: "unset",
  textAlign: "left",
  "&.MuiTableCell-root:last-child": {
    borderRadius: "0 0.7rem 0.7rem 0",
    paddingRight: "2%",
    borderBottom: "none",
  },
  "&.MuiTableCell-root:first-of-type": {
    borderRadius: "0.7rem 0 0 0.7rem",
    paddingLeft: "2.5rem",
    textAlign: "left",
    borderBottom: "none",
  },
});

export const PatientDetailBox = styled(Box)(() => ({
  marginTop: "1.5rem",
  marginBottom: "1.5rem",
}));

export const HeaderStyling = () => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "space-between",
  padding: "1.5rem 1.5rem 1.5rem 0"
});

export const HeaderModuleName = () => ({
  textTransform: "uppercase",
  color: others.DashboardBreadCumb[1],
  marginBottom: "0.5rem",
});

export const PatientDataTableBody = () => ({
  border: `1px solid ${colors.borders[1]}`,
});

export const TableNameDetails = (removeBorder: boolean) => ({
  borderRight: 0,
  padding: 0,
  paddingLeft: "2.5rem",
  borderBottom: removeBorder ? "unset" : `1px solid ${colors.dropShadow[1]}`,
  textDecoration: "underline",
});

export const RecordListRow = () => ({
  height: "4rem",
});

export const PatientTableCell = (removeBorder: boolean) => ({
  borderRight: 0,
  borderBottom: removeBorder ? "unset" : `1px solid ${colors.dropShadow[1]}`,
  borderLeft: 0,
  padding: 0,
  textAlign: "left",
  paddingRight: "2%",
});

export const EligibiliyBodyCell = (removeBorder: boolean) => ({
  borderRight: 0,
  borderBottom: removeBorder ? "unset" : `1px solid ${colors.dropShadow[1]}`,
  borderLeft: 0,
  textAlign: "left",
  paddingLeft: "2rem",
});

export const ViewButton = () => ({
  width: "4.5rem",
});

export const CursorPointer = () => ({
  cursor: "pointer",
});

export const ButtonWidth = () => ({
  minWidth: "7rem",
  textTransform: 'none',
});

export const NoDataCell = () => ({
  py: "3.5rem",
  borderBottom: "none",
});

export const NoDataTitle = () => ({
  fontSize: "1.8rem",
  fontWeight: fontWeight.Weight[4],
  lineHeight: 1.2,
  color: colors.black[17],
  mb: "0.6rem",
});

export const NoDataSubtitle = () => ({
  fontSize: "0.9rem",
  fontWeight: fontWeight.Weight[2],
  lineHeight: 1.35,
  color: colors.black[18],
});